import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('signal-payment-status', storeModule.createStoreModule('signal-payment-status'))
